import {
  RadarChart as RechartsRadar,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  ResponsiveContainer,
} from 'recharts';

interface RadarDataPoint {
  subject: string;
  A: number;
  fullMark: number;
}

interface RadarChartProps {
  data: RadarDataPoint[];
  size?: { width: number; height: number };
  color?: string;
}

export default function RadarChart({
  data,
  size = { width: 200, height: 200 },
  color = '#6366f1',
}: RadarChartProps) {
  return (
    <ResponsiveContainer width={size.width} height={size.height}>
      <RechartsRadar cx="50%" cy="50%" outerRadius="80%" data={data}>
        <PolarGrid stroke="#e5e7eb" />
        <PolarAngleAxis
          dataKey="subject"
          tick={{ fill: '#6b7280', fontSize: 10 }}
        />
        <PolarRadiusAxis angle={30} domain={[0, 100]} tick={false} axis={false} />
        <Radar
          name="Valor"
          dataKey="A"
          stroke={color}
          fill={color}
          fillOpacity={0.3}
        />
      </RechartsRadar>
    </ResponsiveContainer>
  );
}
